import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';

import {
  withContextualAttributeTemplate,
  showContextualAttribute,
  hideContextualAttribute,
  prependAccountAttribute
} from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { APPLY_USERINPUT_TYPES, CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';

import template from '../template/index.pug';
import { BudgetLandScapeTable } from './table';
import { BudgetLandScapeChart } from './chart';

export class RecommendationInlineBudgetView extends Backbone.View {
  initialize({
    data,
    i18n,
    deps,
    router,
    isMCC,
    gridView,
    readOnly,
    isSharedBudget = false,
    gridService,
  }) {
    this.opportunityData = _.first(data.Opportunities);
    this.i18n = i18n;
    this.data = data;
    this.deps = deps;
    this.router = router;
    this.isMCC = isMCC;
    this.isSharedBudget = isSharedBudget;
    this.grid = { gridView };
    this.gridService = gridService;

    const conversionSummaryStatus = data.ConversionSummaryStatus;
    this.tableView = new BudgetLandScapeTable({
      i18n,
      conversionSummaryStatus,
      opportunityData: this.opportunityData,
      appConfig: deps.appConfig,
      readOnly,
      isSharedBudget,
      permissions: deps.permissions,
    });
    this.chartView = new BudgetLandScapeChart({
      tableViewmodel: this.tableView.getViewModel(),
      i18n,
      conversionSummaryStatus,
      legacyRouter: deps.legacyRouter,
    });
    this.tableView.on('selectedRowChanged selectedColumnChanged estimationChanged', () => {
      this.chartView.redraw();
    });
  }

  get events() {
    return {
      'click .apply': this.apply,
      'click .cancel': this.cancel,
      'mouseover .recommendation-inline-budget-view .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .recommendation-inline-budget-view .contextual-tooltip': 'hideContextualAttributePopup',
      'click .recommendation-inline-budget-view .contextual-tooltip': 'scopeRouting',
    };
  }

  scopeRouting(e) {
    this.router(e);
  }

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.data.OpportunityType,
        isExpanding: true,
        self: this,
        recommendationService: this.gridService.recommendationService,
      });
    }, 500);
  }

  render() {
    const { BudgetType, Shared } = this.opportunityData;
    const entity = withContextualAttributeTemplate({
      opportunityId: this.data.Opportunities[0].OpportunityId,
      entityName: this.isSharedBudget ?
        Shared.BudgetName : this.data.Target.CampaignName,
      entityId: this.isSharedBudget ?
        Shared.BudgetId : this.data.Target.CampaignId,
      entityType: this.isSharedBudget ?
        CONTEXTUAL_ENTITY_TYPE.SHARED_BUDGET : CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
      status: 'false', // to check whether it is 1st time to create this view
      isExpandingView: true,
      ariaLabel: this.isSharedBudget ?
        '' : this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: this.data.Target.CampaignName }),
    });

    this.$el.html(template({
      entityName: this.isMCC ? prependAccountAttribute({
        originEntity: entity,
        opportunityId: this.data.Opportunities[0].OpportunityId,
        accountId: this.data.Target.AccountId,
        accountName: this.data.Target.AccountName,
      }) : entity,
      budgetType: BudgetType,
      i18n: this.i18n,
      isSharedBudget: this.isSharedBudget,
    }));
    this.$('.landscape-table').html(this.tableView.render().el);
    this.$('.landscape-chart').html(this.chartView.render().el);

    ko.applyBindings(this.tableView.getViewModel(), this.$('.budget-landscape-actions')[0]);

    return this;
  }

  apply() {
    if (this.tableView.isValid()) {
      let userInputs = null;
      if (!this.tableView.isSuggested()) {
        userInputs = [{
          '@odata.type': APPLY_USERINPUT_TYPES[this.opportunityData.OpportunityType],
          OpportunityId: this.opportunityData.OpportunityId,
          NewBudget: this.tableView.getSelectedNewBudget(),
        }];
      }

      this.trigger('apply', _.extend({
        opportunities: [this.opportunityData],
      }, userInputs && {
        userInputs,
      }));
    }
  }

  cancel() {
    this.trigger('cancel');
  }

  hasChanged() {
    return this.tableView.ko_model.selectedRowIndex() !== this.tableView.config.suggestedIndex;
  }

  remove() {
    this.chartView.remove();
    this.tableView.remove();
    super.remove();
  }
}
